"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TransformBool = void 0;
const class_transformer_1 = require("class-transformer");
const optionalBooleanMapper = new Map([['undefined', undefined], ['true', true], ['false', false], ['null', null]]);
const TransformBool = () => (0, class_transformer_1.Transform)(({
  value
}) => {
  if (typeof value === 'string') {
    return optionalBooleanMapper.get(value);
  } else if (typeof value === 'boolean' || typeof value === 'undefined') {
    return value;
  } else if (!value) {
    return null;
  }
  return undefined;
});
exports.TransformBool = TransformBool;
